import { motion } from "framer-motion";
import { useEffect } from "react";

/**
 * Terms & Conditions — powered by Termly (dynamic embed).
 * Termly injects the terms content into the div[data-id] via their embed-policy.min.js.
 */
const TERMLY_TERMS_ID = "67605172-9e34-4c9e-805d-c1095f328060";
const TERMLY_SCRIPT_SRC = "https://app.termly.io/embed-policy.min.js";

const TermsPage = () => {
    useEffect(() => {
        if (document.querySelector(`script[src="${TERMLY_SCRIPT_SRC}"]`)) return undefined;
        const script = document.createElement("script");
        script.src = TERMLY_SCRIPT_SRC;
        script.async = true;
        document.body.appendChild(script);
        return () => { /* leave script in place — Termly reuses it */ };
    }, []);

    return (
        <main data-testid="terms-page" className="relative">
            {/* Hero */}
            <section className="relative pt-24 md:pt-32 pb-10 md:pb-14 border-b border-[var(--border)]">
                <div className="max-w-3xl mx-auto px-6 md:px-10">
                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <span className="eyebrow-pill">Legal</span>
                        <h1 className="font-display text-[clamp(2.4rem,5.4vw,4.4rem)] leading-[1.04] tracking-tight font-semibold text-[var(--ink)] mt-5">
                            Terms &amp; Conditions.
                        </h1>
                        <p className="text-[var(--ink-soft)] mt-4 text-lg">
                            The terms that govern your use of Lexafide&apos;s website and platform.
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* Termly embed */}
            <section className="py-12 md:py-20">
                <div className="max-w-3xl mx-auto px-6 md:px-10">
                    <div
                        data-testid="termly-embed"
                        name="termly-embed"
                        data-id={TERMLY_TERMS_ID}
                        className="termly-policy-container prose prose-neutral max-w-none"
                    />
                </div>
            </section>
        </main>
    );
};

export default TermsPage;
